import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block"
}
const _hoisted_2 = { class: "title-desc" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "gap-24" }
const _hoisted_5 = { class: "radio-btns" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "timer_container"
}
const _hoisted_8 = {
  key: 0,
  class: "timer"
}
const _hoisted_9 = { class: "gap-48" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_LocaleComponent = _resolveComponent("LocaleComponent")!
  const _component_LoaderView = _resolveComponent("LoaderView")!
  const _component_StatusView = _resolveComponent("StatusView")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.form)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.msg), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('phoneNumberForm.description')), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_CustomInput, {
                id: "phone",
                modelValue: _ctx.formData.client_ctn,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.client_ctn) = $event)),
                  _ctx.handleChange
                ],
                name: "phone",
                "model-value": _ctx.formData.client_ctn,
                "input-mode": "numeric",
                maxlength: "16",
                type: "text",
                autocomplete: "off",
                "custom-class": "input-style",
                "error-class": "error-styles",
                "has-error": _ctx.errors.ctnError.length > 0,
                "error-message": _ctx.errors.ctnError,
                label: _ctx.$t('phoneNumberForm.label'),
                "only-numbers": true,
                format: "phone",
                onBlur: _ctx.ensureCountryCode
              }, null, 8, ["modelValue", "model-value", "has-error", "error-message", "label", "onUpdate:modelValue", "onBlur"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_RadioButton, {
                  label: _ctx.$t('phoneNumberForm.pinOption'),
                  value: "pin",
                  "model-value": _ctx.pinOrSms,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pinOrSms = $event))
                }, null, 8, ["label", "model-value"]),
                _createVNode(_component_RadioButton, {
                  label: _ctx.$t('phoneNumberForm.smsOption'),
                  value: "sms",
                  "model-value": _ctx.pinOrSms,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pinOrSms = $event))
                }, null, 8, ["label", "model-value"])
              ]),
              (_ctx.pinOrSms === 'pin')
                ? (_openBlock(), _createBlock(_component_CustomInput, {
                    key: 0,
                    id: "pin",
                    modelValue: _ctx.formData.client_pin,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.client_pin) = $event)),
                      _ctx.handleChangePin
                    ],
                    name: "pin",
                    "model-value": _ctx.formData.client_pin,
                    "input-mode": "numeric",
                    maxlength: "4",
                    type: "text",
                    autocomplete: "off",
                    "custom-class": "input-style",
                    "error-class": "error-styles",
                    "has-error": _ctx.errors.pinError.length > 0,
                    "error-message": _ctx.errors.pinError,
                    label: _ctx.$t('phoneNumberForm.pinLabel'),
                    "only-numbers": true,
                    format: "pin"
                  }, null, 8, ["modelValue", "model-value", "has-error", "error-message", "label", "onUpdate:modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.showSmsInput)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_ctx.pinOrSms === 'sms')
                      ? (_openBlock(), _createBlock(_component_CustomInput, {
                          key: 0,
                          id: "sms",
                          modelValue: _ctx.formData.client_sms,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.client_sms) = $event)),
                            _ctx.handleChangeSms
                          ],
                          name: "sms",
                          "model-value": _ctx.formData.client_sms,
                          "input-mode": "numeric",
                          maxlength: "6",
                          type: "text",
                          autocomplete: "off",
                          "custom-class": "input-style",
                          "error-class": "error-styles",
                          "has-error": _ctx.errors.smsError.length > 0,
                          "error-message": _ctx.errors.smsError,
                          label: _ctx.$t('phoneNumberForm.smsLabel'),
                          "only-numbers": true,
                          format: "sms"
                        }, null, 8, ["modelValue", "model-value", "has-error", "error-message", "label", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.pinOrSms === 'sms')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_ctx.timerActive)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(Math.floor(_ctx.timer / 60)
                    .toString()
                    .padStart(2, '0')) + ":" + _toDisplayString((_ctx.timer % 60).toString().padStart(2, '0')), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "link",
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendSms && _ctx.sendSms(...args)))
                              }, _toDisplayString(_ctx.$t('phoneNumberForm.resendSmsCode')), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.pinOrSms === 'pin' || (_ctx.pinOrSms === 'sms' && _ctx.showSmsInput))
                ? (_openBlock(), _createBlock(_component_CustomButton, {
                    key: 0,
                    title: _ctx.$t('phoneNumberForm.btnText'),
                    "custom-btn-class": "primary-button",
                    "is-disabled": !_ctx.enabled,
                    onClick: _ctx.getCheckAll
                  }, null, 8, ["title", "is-disabled", "onClick"]))
                : _createCommentVNode("", true),
              (
              _ctx.isSmsShow && _ctx.pinOrSms === 'sms' && !_ctx.showSmsInput && !_ctx.timerActive
            )
                ? (_openBlock(), _createBlock(_component_CustomButton, {
                    key: 1,
                    "is-disabled": !_ctx.enabledSms,
                    title: _ctx.$t('phoneNumberForm.sendSms'),
                    "custom-btn-class": "primary-button",
                    onClick: _ctx.sendSms
                  }, null, 8, ["is-disabled", "title", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_LocaleComponent)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderView, {
          key: 1,
          loading: _ctx.loading,
          title: _ctx.loader.title,
          description: _ctx.loader.description
        }, null, 8, ["loading", "title", "description"]))
      : _createCommentVNode("", true),
    (_ctx.statusView.show)
      ? (_openBlock(), _createBlock(_component_StatusView, {
          key: 2,
          title: _ctx.statusView.title,
          "restart-identification": _ctx.statusView.restartIdentification,
          "restart-decs": _ctx.statusView.restartDecs,
          "status-biometry": _ctx.statusView.status,
          description: _ctx.statusView.description,
          "show-status-biometry": _ctx.statusView.show,
          "no-access-to-camera": false,
          "is-redirect-to-my-beeline": _ctx.statusView.redirectToMyBeeline,
          "site-unavailable": _ctx.statusView.siteUnavailable,
          onUpdateProp: _ctx.updatePropValue
        }, null, 8, ["title", "restart-identification", "restart-decs", "status-biometry", "description", "show-status-biometry", "is-redirect-to-my-beeline", "site-unavailable", "onUpdateProp"]))
      : _createCommentVNode("", true)
  ]))
}